import {PayPerUsePeriod} from '@dms/api/settings';

const FILENAME_PREFIX = 'pay-per-use-leaderboard';
const DATE_SEGMENT_PADDING = 2;

const padDateSegment = (value: number) => value.toString().padStart(DATE_SEGMENT_PADDING, '0');

/**
 * Download base name (no extension) for the leaderboard CSV, e.g.
 * `pay-per-use-leaderboard-last_30_days-20260625`. The date is taken from the
 * caller so the result is deterministic and testable.
 */
export const buildLeaderboardExportFilename = (period: PayPerUsePeriod, date: Date): string => {
  const datePart = `${date.getFullYear()}${padDateSegment(date.getMonth() + 1)}${padDateSegment(date.getDate())}`; // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible

  return `${FILENAME_PREFIX}-${period}-${datePart}`;
};
